import { Avatar, AvatarFallback, AvatarImage } from '@components/ui/avatar';

const AppAvatar = ({ imgUrl, name }: { imgUrl?: string; name?: string }) => {
  const initials = name ? name.slice(0, 2).toUpperCase() : '??';

  return (
    <Avatar>
      <AvatarImage src={imgUrl} alt={name} />
      <AvatarFallback>{initials}</AvatarFallback>
    </Avatar>
  );
};

export default AppAvatar;
